import { Popup } from '../../organisms'
import './Selectdisign.css'

export function Selectdisign (props) { 
  return (
    <div className={`select-item font20Norm select-item_${props.type}`} onClick={props.handlePopupModal}>
      {props.title === 'sort' &&
       <span className='gg-sort'> </span>
      }
      {props.name?.nameRu} 
      <span className={`ingtoggle ${!props.isOpen ? 'gg-poligon-down' : 'gg-poligon-up'} s-16-14`}> </span>
      <Popup isOpen={props.isOpen} ref={props.ref}>
      {props.data.map((el, index) => <p className={`event-text ${props.type === 'activity' ? 'font14Norm': 'font20Norm'}  select-text_${props.type}`}  key={index} onClick={()=> props.handleChangeEvents(el)}>{el.nameRu}</p>)}
       
      </Popup> 
    </div>
   
  )
}